// sessionStorage utility for persistent state management during browser session
// still pending for improvement because after refreshing the page, the state is still preserved

const STORAGE_KEYS = {
  RICH_TEXT_COLLAPSE_STATE: 'rich_text_collapse_state',
  CAPSULE_BOARD_COLLAPSE_STATE: 'capsule_board_collapse_state',
} as const;

export const sessionStorageUtils = {
  // Get value from sessionStorage with fallback
  get: <T>(key: string, defaultValue: T): T => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.warn(`Error reading from sessionStorage key "${key}":`, error);
      return defaultValue;
    }
  },

  // Set value to sessionStorage
  set: <T>(key: string, value: T): void => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Error writing to sessionStorage key "${key}":`, error);
    }
  },

  // Remove value from sessionStorage
  remove: (key: string): void => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.warn(`Error removing from sessionStorage key "${key}":`, error);
    }
  },
};

// Specific functions for rich text collapse
export const richTextStorage = {
  getCollapseState: (): string[] => {
    return sessionStorageUtils.get(STORAGE_KEYS.RICH_TEXT_COLLAPSE_STATE, []);
  },

  setCollapseState: (value: string[]): void => {
    sessionStorageUtils.set(STORAGE_KEYS.RICH_TEXT_COLLAPSE_STATE, value);
  },
};

// Specific functions for capsule board collapse
export const capsuleBoardStorage = {
  getCollapseState: (): string[] => {
    return sessionStorageUtils.get(STORAGE_KEYS.CAPSULE_BOARD_COLLAPSE_STATE, []);
  },

  setCollapseState: (value: string[]): void => {
    sessionStorageUtils.set(STORAGE_KEYS.CAPSULE_BOARD_COLLAPSE_STATE, value);
  },
};

export { STORAGE_KEYS };